/** 樹懶素材插槽（spec 22.2）。正式素材到位前使用佔位圖。 */
export const SLOTH_STATES = [
  'neutral',
  'welcome',
  'working',
  'waiting',
  'reminder',
  'stuck',
  'success',
  'empty',
  'backup',
  'night',
] as const;

export type SlothState = (typeof SLOTH_STATES)[number];

export function isSlothState(value: unknown): value is SlothState {
  return typeof value === 'string' && (SLOTH_STATES as readonly string[]).includes(value);
}

export interface SlothContext {
  /** 資料庫是否已播種；false 代表首次使用或剛清除資料。 */
  isSeeded: boolean;
  saving?: boolean;
  reminderCount?: number;
  waitingCount?: number;
  stuckCount?: number;
  justCompleted?: boolean;
  backupOverdue?: boolean;
  theme?: 'light' | 'dark';
}

/**
 * 規則式狀態選擇，不使用 AI 生成（spec 8.2）。
 * 順序：空白狀態 → 正在保存 → 剛完成 → 提醒 → 卡住 → 等待 → 備份 → 待機。
 */
export function resolveSlothState(context: SlothContext): SlothState {
  if (!context.isSeeded) return 'empty';
  if (context.saving) return 'working';
  if (context.justCompleted) return 'success';
  if ((context.reminderCount ?? 0) > 0) return 'reminder';
  if ((context.stuckCount ?? 0) > 0) return 'stuck';
  if ((context.waitingCount ?? 0) > 0) return 'waiting';
  if (context.backupOverdue) return 'backup';
  return context.theme === 'dark' ? 'night' : 'neutral';
}

export const SLOTH_ALT_TEXT: Record<SlothState, string> = {
  neutral: '樹懶助理安靜地待在桌邊',
  welcome: '樹懶助理歡迎你回到工作台',
  working: '樹懶助理正在整理資料',
  waiting: '樹懶助理在等待回覆',
  reminder: '樹懶助理提醒你有事項待處理',
  stuck: '樹懶助理陪著你面對卡住的工作',
  success: '樹懶助理為完成的工作感到開心',
  empty: '樹懶助理站在空白的工作台前',
  backup: '樹懶助理提醒你該備份了',
  night: '樹懶助理在夜燈下休息',
};
